import axiosIns from '@/libs/axios'

export default {
  get: (() => axiosIns.get('institution-data')),
  getData: (() => axiosIns.get('auth/institution-data')),

}
